import { otherInstalledIntegration } from "components/Integrations/utils/resourcesInstalledUtil";

import { ComputerRegistrationForm } from "./computer-registration-form";
import { SelfHostedInstaller } from "./types";

export const selfHostedInstaller: SelfHostedInstaller = {
  "iam-write": {
    items: {
      sshSessionAuditSource: {
        options: {
          splunk: {
            items: {
              sessionAudit: {
                optionProvider: otherInstalledIntegration({
                  integration: "splunk",
                  component: "session-audit",
                }),
              },
            },
          },
        },
      },
    },
    footer: (context, environmentId, config) => {
      return (
        <ComputerRegistrationForm
          context={context}
          config={config}
          environmentId={environmentId}
        />
      );
    },
  },
};
